export interface DemoComment {
  id: string;
  user: string;
  avatar: string;
  content: string;
  time: string;
  likes: number;
}

export const comments: DemoComment[] = [
  {
    id: "c1",
    user: "奶茶不加冰",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20cheerful%20girl%20face%20with%20a%20bubble%20tea%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20friendly%20casual%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-cmt-01&orientation=squarish",
    content: "笑到把水喷出来了，反复看了三遍还是忍不住，太真实了吧！",
    time: "2 小时前",
    likes: 328,
  },
  {
    id: "c2",
    user: "今天也要加油鸭",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20positive%20young%20person%20face%20with%20a%20smile%2C%20warm%20orange%20and%20beige%20palette%2C%20clean%20circular%20background%2C%20encouraging%20friendly%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-cmt-02&orientation=squarish",
    content: "看完瞬间被治愈了，谢谢博主，这就是我下班后最需要的快乐。",
    time: "5 小时前",
    likes: 216,
  },
  {
    id: "c3",
    user: "摄影师老王",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20bearded%20photographer%20face%20with%20a%20camera%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20creative%20friendly%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-cmt-03&orientation=squarish",
    content: "画面质感和节奏都很舒服，剪辑思路值得学习，已收藏。",
    time: "昨天",
    likes: 154,
  },
  {
    id: "c4",
    user: "夜猫子小姐",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20sleepy%20cute%20girl%20face%20with%20a%20moon%2C%20warm%20orange%20and%20soft%20cream%20palette%2C%20clean%20circular%20background%2C%20cozy%20night%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-cmt-04&orientation=squarish",
    content: "凌晨两点刷到，本来想睡了结果一口气看完了全部，罪过罪过。",
    time: "昨天",
    likes: 189,
  },
  {
    id: "c5",
    user: "摸鱼小能手",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20playful%20office%20worker%20face%20with%20a%20fish%2C%20warm%20orange%20and%20beige%20palette%2C%20clean%20circular%20background%2C%20funny%20relaxed%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-cmt-05&orientation=squarish",
    content: "上班摸鱼偷偷看，结果差点被老板抓到，还好憋住了没笑出声。",
    time: "2 天前",
    likes: 402,
  },
  {
    id: "c6",
    user: "爱吃辣的小陈",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20happy%20food%20lover%20face%20with%20chili%20pepper%2C%20warm%20orange%20and%20red%20palette%2C%20clean%20circular%20background%2C%20cheerful%20appetite%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-cmt-06&orientation=squarish",
    content: "这就是我每天睡前必刷的快乐，评论区也很搞笑，一起笑哈哈哈。",
    time: "2 天前",
    likes: 97,
  },
  {
    id: "c7",
    user: "旅行的意义",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20traveler%20face%20with%20a%20camera%20and%20hat%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20adventurous%20friendly%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-cmt-07&orientation=squarish",
    content: "刷到就停不下来，希望博主多多更新，已经关注啦，期待下一期。",
    time: "3 天前",
    likes: 143,
  },
  {
    id: "c8",
    user: "隔壁的程序猿",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20nerdy%20programmer%20face%20with%20glasses%2C%20warm%20orange%20and%20beige%20palette%2C%20clean%20circular%20background%2C%20friendly%20geeky%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-cmt-08&orientation=squarish",
    content: "这个内容分类做得挺清楚的，一进来就找到了我喜欢的类型，好评。",
    time: "4 天前",
    likes: 76,
  },
];